import { Injectable } from '@angular/core';
import { ConnectorService } from '../connector.service';

@Injectable({
  providedIn: 'root'
})
export class TokenMonitorService {
  private checkInterval: any;
  private readonly CHECK_INTERVAL_MS = 60000; // Vérifier toutes les minutes

  constructor(private connectorService: ConnectorService) {}

  /**
   * Démarre la surveillance du token
   */
  startMonitoring(): void {
    if (this.checkInterval) {
      return; // Déjà en cours
    }

    this.checkInterval = setInterval(() => {
      this.checkTokenStatus();
    }, this.CHECK_INTERVAL_MS);

    // Vérification immédiate
    this.checkTokenStatus();
  }

  /**
   * Arrête la surveillance du token
   */
  stopMonitoring(): void {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
      this.checkInterval = null;
    }
  }

  /**
   * Vérifie le statut du token
   */
  private checkTokenStatus(): void {
    // Si l'utilisateur n'est pas connecté, ne rien faire
    if (!this.connectorService.isConnected()) {
      return;
    }

    // Vérifier si le token est expiré
    if (this.connectorService.isTokenExpired()) {
      console.log('Token expiré détecté par le moniteur, déconnexion automatique...');
      this.connectorService.disconnection();
      return;
    }

    // Vérifier si le token va expirer bientôt (optionnel - pour afficher un avertissement)
    if (this.connectorService.isTokenExpiringSoon(5)) {
      console.log('Attention: Le token va expirer dans moins de 5 minutes');
      // Ici on pourrait afficher une notification à l'utilisateur
    }
  }
}
